import { ICreateTrackingEvent } from '@sdk/contracts';
import { useMutation } from '@tanstack/react-query';

import { sdk } from '@/services';

const TrackingEventService = sdk.getService('TrackingEventService');

export const useMutateTrackingEvents = () => {
  const { mutate: createTrackingEvent, isPending: isTrackingEvent } = useMutation({
    mutationFn: (trackingEvent: ICreateTrackingEvent) => {
      return TrackingEventService.createTrackingEvent(trackingEvent);
    }
  });

  return {
    createTrackingEvent,
    isPending: isTrackingEvent
  };
};
